import { render, staticRenderFns } from "./PaoSearch.vue?vue&type=template&id=864c220e&scoped=true"
import script from "./PaoSearch.vue?vue&type=script&lang=js"
export * from "./PaoSearch.vue?vue&type=script&lang=js"
import style0 from "./PaoSearch.vue?vue&type=style&index=0&id=864c220e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864c220e",
  null
  
)

export default component.exports